import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import Picker from '../../../../Common/Picker';
import CValidator from '../../../../Common/CValidator';
import { useGetBusinessElementListByType } from '../../../../../hooks/services/sKPI/useOfBusinessElement';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import PropTypes from 'prop-types';
import MessageBox from '../../../../Common/Message/MessageBox';
import { __MessageTypes } from '../../../../../common/Dictionaries';
import { showMessage } from '../../../../../common/Helpers';
import { addListBoardElement } from '../../../../../services/sKPI/board.service';

const SidePanelElementSelection = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_BoardId = null,
        inputParam_SetterBoardElements = null,
        inputParam_SetterStatusFly = null,
        inputParam_SelectedElementType = null,
    } = props;

    const [selectedElements, setSelectedElements] = useState(null);
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [isInvalidForm, setIsInvalidForm] = useState(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [businessElementList, setBusinessElementList] = useState(null);
    useGetBusinessElementListByType(inputParam_SelectedElementType.id, businessElementList, setBusinessElementList, inputParam_IsPanelOpen, inputParam_SelectedElementType.codeFieldName, inputParam_SelectedElementType.nameFieldName)

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)
        setIsInvalidForm(false);
    };

    const onSelectElements = () => {
        const isValidForm = selectedElements !== null;

        if (isValidForm) {

            const itemsToSave = [];

            selectedElements.forEach(element => {
                itemsToSave.push({id: 0, elementId: element.id, boardId: parseInt(inputParam_BoardId), htmlColor: ""});
            });

            addListBoardElement(inputParam_BoardId, itemsToSave).then((response) => {
                if (response.data.succeeded) {
                    inputParam_SetterBoardElements && inputParam_SetterBoardElements(null);
                    inputParam_SetterStatusFly && inputParam_SetterStatusFly(prevState => ({
                        fireUpdate: true,
                    }))
    
                    setBusinessElementList(null);
                    setSelectedElements(null);
                    setIsInvalidForm(false)
                    onDismissPanel();
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            setIsInvalidForm(true)
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requiredpartys'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setSelectedElements(null);
    };
    
    const onClosePanel = () => {
        setBusinessElementList(null);
        onDismissPanel();
    };

    const onChangeSelectedElements = (currentNode, selectedNodes) => {
        setSelectedElements(selectedNodes)

        let items = [...businessElementList];

        items = recurrentCheckItems(items, currentNode);

        setBusinessElementList(items);   
    };
    
    const recurrentCheckItems = (items, currentNode) => {
        items.forEach(x => {
            if (x.children !== undefined && x.children !== null && x.children.length > 0) {
                x.children = recurrentCheckItems(x.children, currentNode);
            }

            if (x.id === currentNode.id) {
                x.checked = currentNode.checked;
            }
        })

        return items;
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={ onSelectElements } styles={_global_buttonStyles}>{ t('data-lang-btn-add') }</PrimaryButton>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-elements') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row style={{height: "100px"}} className="pt-3">
                    <Col>
                    {
                        businessElementList &&
                        <Picker
                            data={ businessElementList !== null ? businessElementList : [] }
                            mode="hierarchical"
                            className="dropdown-checkbox"
                            isInValid={ isInvalidForm }
                            texts={{ placeholder: t('data-lang-lbl-chooses') }}
                            onChange={ onChangeSelectedElements }
                            labelText={ t('data-lang-lbl-elements') }
                            refresh={true}
                        />
                        }
                        <CValidator isInValid={ isInvalidForm } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelElementSelection.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_SetterBoardElements: PropTypes.func.isRequired,
    inputParam_SetterStatusFly: PropTypes.func.isRequired,
    inputParam_SelectedElementType: PropTypes.object.isRequired,
};

export default SidePanelElementSelection;